var map = {
	"./paper/pdf/Paper_Straws_SGS_pdf.pdf": 373,
	"./paper/png/Paper_Straws_SGS.png": 374,
	"./pla/pdf/BPI_8089616_1_pdf.pdf": 375,
	"./pla/pdf/BRC_1650578_pdf.pdf": 376,
	"./pla/pdf/PLA_test_report_pdf.pdf": 377,
	"./pla/pdf/certificate_for_the_use_of_green_mark_16124_pdf.pdf": 378,
	"./pla/pdf/din_certco_8C143_pdf.pdf": 379,
	"./pla/png/BPI_8089616_1.png": 380,
	"./pla/png/BRC_1650578.png": 381,
	"./pla/png/HACCP.png": 382,
	"./pla/png/ISO13067_10030887_001.png": 383,
	"./pla/png/ISO14604_14000096_001.png": 384,
	"./pla/png/ISO22000.png": 385,
	"./pla/png/PLA_test_report.png": 386,
	"./pla/png/certificate_for_the_use_of_green_mark_16124.png": 387,
	"./pla/png/din_certco_7P0391.png": 388,
	"./pla/png/din_certco_8C143.png": 389,
	"./pla/png/din_certco_9G0097.png": 390,
	"./pla/png/used_certified_biobased_product.png": 391,
	"./pp/pdf/CT_2019_30439A_pdf.pdf": 134,
	"./pp/pdf/CT_2019_30439_8941_pdf.pdf": 135,
	"./pp/pdf/CT_2019_30440A_pdf.pdf": 136,
	"./pp/pdf/CT_2019_30440_9301_pdf.pdf": 137,
	"./pp/pdf/CT_2019_30441A_pdf.pdf": 138,
	"./pp/pdf/CT_2019_30441_8746_pdf.pdf": 139,
	"./pp/pdf/CT_2019_30442A_pdf.pdf": 140,
	"./pp/pdf/CT_2019_30443A_pdf.pdf": 141,
	"./pp/pdf/CT_2019_30443_2015_pdf.pdf": 142,
	"./pp/pdf/CT_2019_30444A_pdf.pdf": 143,
	"./pp/pdf/CT_2019_30444_3901_pdf.pdf": 144,
	"./pp/pdf/CT_2019_30445A_pdf.pdf": 145,
	"./pp/pdf/CT_2019_30445_1598A_pdf.pdf": 146,
	"./pp/pdf/CT_2019_30446A_pdf.pdf": 147,
	"./pp/pdf/CT_2019_30446_1005_pdf.pdf": 148,
	"./pp/pdf/CT_2019_30447A_pdf.pdf": 149,
	"./pp/pdf/CT_2019_30447_W6053_pdf.pdf": 150,
	"./pp/pdf/CT_2019_30448A_pdf.pdf": 151,
	"./pp/pdf/CT_2019_30448_8721_pdf.pdf": 152,
	"./pp/pdf/CT_2019_30449A_pdf.pdf": 153,
	"./pp/pdf/CT_2019_30449_9904_pdf.pdf": 154,
	"./pp/pdf/CT_2019_30450A_pdf.pdf": 155,
	"./pp/pdf/CT_2019_30450_pdf.pdf": 156,
	"./pp/pdf/CT_2019_30451_pdf.pdf": 157,
	"./pp/pdf/CT_2019_30452_pdf.pdf": 158,
	"./pp/pdf/CT_2019_30457A_pdf.pdf": 159,
	"./pp/pdf/CT_2019_30457_pdf.pdf": 160,
	"./pp/pdf/CT_2019_30460_pdf.pdf": 161,
	"./pp/pdf/PP_2019 PPbag_pdf.pdf": 162,
	"./pp/png/CT_2019_30439A.png": 163,
	"./pp/png/CT_2019_30439_8941.png": 164,
	"./pp/png/CT_2019_30440A.png": 165,
	"./pp/png/CT_2019_30440_9301.png": 166,
	"./pp/png/CT_2019_30441A.png": 167,
	"./pp/png/CT_2019_30441_8746.png": 168,
	"./pp/png/CT_2019_30442A.png": 169,
	"./pp/png/CT_2019_30443A.png": 170,
	"./pp/png/CT_2019_30443_2015.png": 171,
	"./pp/png/CT_2019_30444A.png": 172,
	"./pp/png/CT_2019_30444_3901.png": 173,
	"./pp/png/CT_2019_30445A.png": 174,
	"./pp/png/CT_2019_30445_1598A.png": 175,
	"./pp/png/CT_2019_30446A.png": 176,
	"./pp/png/CT_2019_30446_1005.png": 177,
	"./pp/png/CT_2019_30447A.png": 178,
	"./pp/png/CT_2019_30447_W6053.png": 179,
	"./pp/png/CT_2019_30448A.png": 180,
	"./pp/png/CT_2019_30448_8721.png": 181,
	"./pp/png/CT_2019_30449A.png": 182,
	"./pp/png/CT_2019_30449_9904.png": 183,
	"./pp/png/CT_2019_30450.png": 184,
	"./pp/png/CT_2019_30450A.png": 185,
	"./pp/png/CT_2019_30451.png": 186,
	"./pp/png/CT_2019_30452.png": 187,
	"./pp/png/CT_2019_30457.png": 188,
	"./pp/png/CT_2019_30457A.png": 189,
	"./pp/png/CT_2019_30460.png": 190,
	"./pp/png/PP_2019 PPbag.png": 191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 372;